<template>
  <Dashboard
    class="questionnaires"
    title="Questionnaires"
  >
    <Button
      class="questionnaires--add-button"
      title="Add questionnaire"
      to=""
      active=true
      showAddIcon=true
      v-on:handleClick="handleModal({}, 'Add', 0)"
    />

    <Table
      recordsfoundishidden=true
      :data="questionnairies"
      :isloading="isLoading"
      v-if="selectedApplicationId"
    >
      <template v-slot:titles>
        <th>ID</th>
        <th>Title</th>
        <th></th>
      </template>

      <template v-slot:row>
        <tr
          v-for="(item, index) of questionnairies"
          v-bind:key="index"
        >
          <TdId :id="item.id"/>

          <TdTitle              
            :title="item.name"
          />

          <TdButtons>
            <RoundedButton
              title="Sections"                
              v-on:handleClick="handleSectionsButton(item.id)"
            />

            <RoundedButton
              title="Edit"                
              v-on:handleClick="handleModal(item, 'Edit', index)"
            >
              <EditIcon/>
            </RoundedButton>

            <RoundedButton
              title=""
              danger=true
              v-on:handleClick="handleDelete(item.id, index)"
            >
              <TrashIcon/>
            </RoundedButton>
          </TdButtons>
        </tr>
      </template>
    </Table>

    <NoApplicationSelected v-else/>

    <Modal 
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
    >      
      <template v-slot:title>
        <h3>{{ modal.title }} questionnaire</h3>
      </template>

      <template v-slot:content>
        <form>
          <div class="row">
            <Input
              class="col-24"
              placeholder="Name"
              type="text"
              :value="modal.data.name"
              v-model="modal.data.name"
            />

            <div class="col-24 input">
              <p>Outro</p>

              <vue-mce
                :config="config"
                v-model="modal.data.outro"
              />            
            </div>
          </div>
          
          <ButtonForm
            title="Save"
            v-on:handleClick="handleModalButton()"
          />
        </form>
      </template>      
    </Modal>
  </Dashboard>
</template>

<script>
  import { API } from '../../services/api.ts'
  import Dashboard from '../../components/dashboard/dashboard.vue'
  import Button from '../../components/buttons/button.vue'
  import RoundedButton from '../../components/buttons/roundedButton.vue'
  import NoApplicationSelected from '../../components/error/noApplicationSelected.vue'
  import Modal from '../../components/modal/modal.vue'
  import Input from '../../components/form/input.vue'
  import RadioInput from '../../components/form/radio.vue'
  import ButtonForm from '../../components/form/button.vue'

  import Table from '../../components/table/table.vue'
  import TdTitle from '../../components/table/td/title.vue'
  import TdId from '../../components/table/td/id.vue'
  import TdSortOrder from '../../components/table/td/sortOrder.vue'
  import TdButtons from '../../components/table/td/buttons.vue'
  import TrashIcon from '../../icons/trash.vue'
  import EditIcon from '../../icons/edit.vue'
  import { component } from 'vue-mce'

  export default {
    name: 'Questionnairies',
    components: {
      Dashboard,
      Button,
      RoundedButton,
      NoApplicationSelected,
      Modal,
      Input,
      RadioInput,
      ButtonForm,
      Table,
      TdTitle,
      TdId,
      TdSortOrder,
      TdButtons,
      TrashIcon,
      EditIcon,
      'vue-mce': component
    },
    data() {
      return {
        config: {
          theme: 'modern',          
          menubar: false,
          plugins: 'code lists link',
          toolbar: 'styleselect | bold italic strikethrough | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat | code',
          style_formats : [
            {title : 'H2', block : 'h2'},
            {title : 'H3', block : 'h3'},
            {title : 'H4', block : 'h4'},
            {title: 'Color block', inline: 'span', classes: 'well', styles: { backgroundColor: 'whitesmoke', display: 'block'}},
            {title : 'Quotation', block : 'blockquote'},
          ]
        },
        selectedApplicationId: localStorage.selectedApplicationId,
        isLoading: true,
        questionnairies: [],
        modal: {
          isHidden: true,
          title: '',
          index: 0,
          data: {}
        }
      }
    },
    methods: {
      handleSectionsButton: function(id) {
        window.location.href = `/questionnaires/sections/${id}`;
      },
      handleModal: function(item, title, index) {
        this.modal.title = title;

        if (title === 'Add') {
          if (this.modal.isHidden === true) {
            this.modal.isHidden = false;
            this.modal.data = {
              name: '',
              outro: ''
            }
          } else {
            this.modal.isHidden = true;
          }
        } else {
          if (this.modal.isHidden === true) {
            this.modal.index = index;
            
            API.get(
              `index.cfm?act=questionnaires.item&id=${item.id}`
            ).then(
              response => {
                this.modal.isHidden = false;
                this.modal.data = response.data.data;
              }
            )
          } else {
            this.modal.isHidden = true;
          }
        }
      },
      handleModalButton: function() {
        if (this.modal.title === 'Add') {
          API.post(
            `index.cfm?act=questionnaires.item`,
            {
              name: this.modal.data.name,
              outro: this.modal.data.outro
            }
          ).then(
            response => {
              location.reload();
            }
          )
        } else {
          API.patch(
            `index.cfm?act=questionnaires.item&id=${this.modal.data.id}`,
            {
              name: this.modal.data.name,
              outro: this.modal.data.outro
            }
          ).then(
            response => {
              this.questionnairies[this.modal.index].name = response.data.data.name;        
              this.modal.isHidden = true;
            }
          )
        }
      },
      handleDelete: function(id, index) {
        if (confirm("Are you sure you want to delete this questionnary?")) {
          API.delete(
            `index.cfm?act=questionnaires.item&id=${id}`
          ).then(
            response => {
              this.questionnairies.splice(index, 1);
            }
          )
        }
      },
    },
    mounted() {
      const self = this;
      
      API.get(
      'index.cfm?act=questionnaires.list'
      ).then(
        response => {
          console.log(response.data.data);
          this.questionnairies = response.data.data;
          this.isLoading = false;
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');        
          self.selectedApplicationId = null
        }
      });
    }
  }
</script>

<style lang="scss">
  .questionnaires {
    &--add-button {
      float: right;
    }

    .table {
      float: left;
    }
  }
  
</style>